import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  private storage: Storage;
  changes$: any;
  constructor() {
    this.storage = window.localStorage;
  }

  set(key: string, value: any): boolean {
    if (this.storage) {
      this.storage.setItem(key, JSON.stringify(value));
      return true;
    }
    return false;
  }

  get(key: string): any {
    if (this.storage) {
      return JSON.parse(this.storage.getItem(key)!);
    }
    return null;
  }

  remove(key: string): boolean {
    if (this.storage) {
      this.storage.removeItem(key);
      return true;
    }
    return false;
  }

  // Preferencias do aparelho (prefixo "fila:", ex.: ultimo usuario e ultima unidade) sobrevivem ao logout.
  clear(): boolean {
    if (this.storage) {
      const preservadas = Object.keys(this.storage)
        .filter(k => k.startsWith('fila:'))
        .map(k => [k, this.storage.getItem(k)!] as const);
      this.storage.clear();
      preservadas.forEach(([k, v]) => this.storage.setItem(k, v));
      return true;
    }
    return false;
  }
}
